import { render } from "./PaymentDelivery.vue?vue&type=template&id=4fa19078"
import script from "./PaymentDelivery.vue?vue&type=script&lang=js"
export * from "./PaymentDelivery.vue?vue&type=script&lang=js"

import "./PaymentDelivery.vue?vue&type=style&index=0&id=4fa19078&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__